"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size900 = exports.size800 = exports.size700 = exports.size600 = exports.size500 = exports.size50 = exports.size400 = exports.size300 = exports.size200 = exports.size1100 = exports.size1000 = exports.size100 = exports.size0 = void 0;
const size0 = "0px";
exports.size0 = size0;
const size50 = "2px";
exports.size50 = size50;
const size100 = "5px";
exports.size100 = size100;
const size200 = "10px";
exports.size200 = size200;
const size300 = "15px";
exports.size300 = size300;
const size400 = "20px";
exports.size400 = size400;
const size500 = "25px";
exports.size500 = size500;
const size600 = "30px";
exports.size600 = size600;
const size700 = "40px";
exports.size700 = size700;
const size800 = "50px";
exports.size800 = size800;
const size900 = "60px";
exports.size900 = size900;
const size1000 = "100px";
exports.size1000 = size1000;
const size1100 = "160px";
exports.size1100 = size1100;